import React, { useState } from 'react';
import { useStudioStore } from '../../stores/useStudioStore';

export const VarPanelConfig: React.FC = () => {
  const { openaiKey, setOpenaiKey } = useStudioStore();
  const [showOai, setShowOai] = useState(false);

  return (
    <div className="panel" id="varPanelA">
      <div className="panel-scroll">
        <div className="section">
          <div className="section-label">API key — OpenAI</div>
          <div className="key-wrap">
            <input 
              type={showOai ? 'text' : 'password'} 
              value={openaiKey}
              onChange={e => setOpenaiKey(e.target.value)}
              placeholder="sk-… (optional override)" 
            />
            <button className="key-toggle" onClick={() => setShowOai(!showOai)}>
              {showOai ? 'hide' : 'show'}
            </button>
          </div>
        </div>

        <div className="section" style={{ borderBottom: 'none' }}>
          <div className="section-label">How it works</div>
          <div style={{ fontSize: '11px', color: 'var(--text3)', lineHeight: 1.8 }}>
            1. Upload the finished reference shots (front/back/side/etc — already final quality, one design)<br />
            2. Add a variant per color/print, with a swatch or print reference image + notes<br />
            3. Each angle × variant is generated as ONE clean recolor call — no grid, no model re-lock<br />
            4. Quality is forced to High for maximum fidelity<br />
            5. Review, approve, download
          </div>
        </div>
      </div>
    </div>
  );
};
